<template>
    <div
        class="
            product-shop-form-submit-bar
            d-flex
            align-center
            justify-center
            bg-background
            border-t-sm
            pt-2
            pt-md-0
        "
    >
        <v-row
            class="justify-center max-w-sm-floor h-100"
            density="compact"
        >
            <v-col
                cols="auto"
                class="d-flex flex-column justify-center"
            >
                <div
                    v-if="currentSku && currentImage"
                    class="position-relative"
                >
                    <ProductsLayeredImage
                        class="cursor-pointer prod-floating-image"
                        :key="`prod-floating-image-${currentImage.uid}`"
                        :index="0"
                        :image-object="currentImage"
                        :image-stack="imageStack"
                        :top-image-props="{
                            class: 'object-fit-contain aspect-ratio-1 w-100',
                            label: skuLabel || currentSku.detailWithColor,
                            type: 'x-small',
                            width: '64px',
                            disableDropShadow: true
                        }"
                        :low-images-props="{
                            class: 'object-fit-contain aspect-ratio-1 w-100',
                            disableDropShadow: true
                        }"
                        @click="goTo(0)"
                    ></ProductsLayeredImage>
                </div>
            </v-col>
            <v-col
                class="d-flex flex-column flex-grow-1 flex-shrink-0"
            >
                <div
                    class="flex-grow-0 flex-shrink-1 font-size-7 font-weight-medium text-center"
                >
                    <span
                        class="text-truncate"
                    >
                        {{ skuLabel ? `${productName}, ${skuLabel}` : currentSku?.detailWithColor }}
                    </span>
                </div>
                <div
                    class="flex-grow-1 flex-shrink-0 py-1"
                >
                    <slot name="submitButton" />
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts" setup>
    import type { Sku, FullImage, FullImageStack } from '~/types';
    import { useGoTo } from 'vuetify';
    import ProductsLayeredImage from '~/components/products/ProductsLayeredImage/ProductsLayeredImage.vue';

    const props = defineProps<{
        productName: string;
        currentSku: Nilish<Sku>;
        imageStack?: Nilish<FullImageStack>;
        skuLabel?: Nullable<string>;
    }>();

    const slots = defineSlots<{
        submitButton: () => void;
    }>();

    const goTo = useGoTo();

    const currentImage = computed<Nilish<FullImage>>(() => {
        const imgs = props.currentSku?.images;

        if (imgs?.length) {
            return imgs.find((img) => img.groupKey) ?? imgs[0];
        }
    });
</script>

<style lang="scss">
$product-shop-form-submit-bar-padding-x: 16px;

.product-shop-form {
    &-submit-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        min-height: 80px;
        z-index: 999;
        padding-left: $product-shop-form-submit-bar-padding-x;
        padding-right: $product-shop-form-submit-bar-padding-x;
    }
}

.prod-floating-image {
    width: 46px;
    height: 46px;
}
</style>
